import React, { FC } from 'react'

import { MoneyFragment } from '../../../../../../../graphql/search'
import {
  dropZeroCents,
  formatAsCurrencyWithCommasOrZero,
} from '../../../../../../../utils/priceTools'
import * as Styled from './styled'

export interface SalesClassificationCardProps {
  name: string
  value: MoneyFragment
  onClick: () => void
}

export const SalesClassificationCard: FC<SalesClassificationCardProps> = ({
  name,
  value,
  onClick,
}) => {
  return (
    <Styled.Card onClick={onClick}>
      <Styled.CardText>
        <Styled.CardLabel>{name}</Styled.CardLabel>
        <Styled.SalesOverview>
          {dropZeroCents(formatAsCurrencyWithCommasOrZero({ amount: parseFloat(value.amount) }))}
        </Styled.SalesOverview>
      </Styled.CardText>
    </Styled.Card>
  )
}
